<template>
  <div class="footer-container">
    <div class="header-container">
      <div class="article">
        <div @click="lookDetail(registerAggreement)">
          {{ $t("nav.register") }}
        </div>
        <div v-for="(item, index) in list" :key="index">
          <div @click="lookDetail(item)">{{ item.title }}</div>
        </div>
        <div v-for="(item, index) in helpList" :key="index">
          <div @click="lookDetail(item)">{{ item.title }}</div>
        </div>
      </div>
      <div class="logo">
        {{ storeInfo.name | uppercase }}
      </div>
      <div class="time">
        <div class="time-title">
          {{ $t("home.status") }}：{{
            storeInfo.open ? $t("home.open") : $t("home.close")
          }}
        </div>
        <div class="address">
          <div>{{ storeInfo.address.address1 }}</div>
          <div>{{ storeInfo.mobile }}</div>
        </div>
      </div>
    </div>
    <div class="copyright">{{ copyRightText }}</div>

    <!-- begin 对话框 -->
    <v-dialog v-model="showDetail" width="800">
      <v-card>
        <v-card-title class="headline grey lighten-2" primary-title>
          {{ activeItem.title }}
        </v-card-title>

        <v-card-text>
          <div v-html="activeItem.content"></div>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="showDetail = false">
            OK
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- end 对话框 -->
  </div>
</template>

<script>
import { mapState } from "vuex";
import { uppercase } from "../../utils";
import Store from "@/api/store";

export default {
  computed: {
    ...mapState(["storeInfo"])
  },
  filters: {
    uppercase
  },

  data() {
    return {
      list: [],
      helpList: [],
      activeItem: {},
      showDetail: false,
      registerAggreement: {},
      copyRightText: "© 2019 G-eat.es. All Rights Reserved."
    };
  },

  created() {
    this.getPages();
    this.getCopyRight();
    this.getHelpList();
    this.getRegisterAggreement();
  },

  methods: {
    lookDetail(item) {
      this.activeItem = item;
      this.showDetail = true;
    },

    getPages() {
      console.log("清空缓存后遗症=========");
      Store.getPages().then(res => {
        console.log("清空缓存后遗症=========", res);
        if (!res.data.isError) {
          this.list = res.data.data;
        } else {
          console.log("清空缓存后遗症=========");
          this.$router.push({ name: "index" });
        }
      });
    },
    getCopyRight() {
      Store.getCopyRight().then(res => {
        if (!res.data.isError) {
          this.copyRightText = (res.data.data && res.data.data.content) || "";
        }
      });
    },
    getHelpList() {
      Store.getHelpList().then(res => {
        if (!res.data.isError) {
          this.helpList = res.data.data || [];
        }
      });
    },
    getRegisterAggreement() {
      Store.getRegisterAggreement().then(res => {
        if (!res.data.isError) {
          this.registerAggreement = (res.data.data && res.data.data[0]) || {};
        }
      });
    }
  }
};
</script>

<style scoped lang="sass" src="./footer.sass"></style>
